import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

export default function CustomTab({ tabs,setValue,value,getAssemblysTypeList, getAssemblysTypeActualConfigList }) {

const handleChange = (event, newValue) => {
  setValue(newValue);
  if (newValue === 0) {
    getAssemblysTypeList('fetch');
  } else {
    getAssemblysTypeActualConfigList('fetch');
  }
};

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        slotProps={{ 
         indicator: {
         sx: { backgroundColor: '', height: 2 }
           }
          }}
        sx={{
          border: '1px solid #D7D7D7',
          borderRadius: 1,
          px: 1,
          minHeight: 'auto',
          p:0
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            disableRipple
            sx={{
            fontFamily: 'Roboto-SemiBold',
            fontWeight: 500,
            fontSize: '13px',
            fontStyle: 'normal',
            lineHeight: '100%',
            letterSpacing: 0,
            textTransform: 'none',
            color: value === index ? '#3f51b5' : 'black',
            minHeight: 'auto',
           px: 2,
           }}
          />
        ))}
      </Tabs>

      <Box sx={{ mt: 2 }}>{tabs[value].content}</Box>
    </Box>
  );
}
